import { useEffect, Component } from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import ValueProps from "@/components/site/ValueProps";
import Marquee from "@/components/site/Marquee";
import Categories from "@/components/site/Categories";
import Reviews from "@/components/site/Reviews";
import LocationSection from "@/components/site/LocationSection";
import Faq from "@/components/site/Faq";
import FinalCta from "@/components/site/FinalCta";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

function AppShell() {
  useLenis();
  return (
    <div className="relative min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <ValueProps />
        <Marquee />
        <Categories />
        <Reviews />
        <LocationSection />
        <Faq />
        <FinalCta />
      </main>
      <FloatingWhatsApp />
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-8 text-center">
          <p className="font-display text-2xl">
            Algo salió mal. Por favor recarga la página.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
